import VxeTextareaComponent from './src/textarea';
import { dynamicApp } from '../dynamics';
export var VxeTextarea = Object.assign(VxeTextareaComponent, {
    install: function (app) {
        app.component(VxeTextareaComponent.name, VxeTextareaComponent);
    }
});
export var Textarea = VxeTextarea;
dynamicApp.component(VxeTextareaComponent.name, VxeTextareaComponent);
export default VxeTextarea;
